import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React, { memo, useRef } from 'react';

import useScreenSize from '../../../../util/hooks/useScreenSize';
import useStoryblokImage from '../../../../util/hooks/useStoryblokImage';
import ProgressiveImage from '../../../Image/ProgressiveImage';

/**
 * @param {object} props
 * @param {object} props.image
 * @param {string} props.position
 */
const StoryblokBlogPostHeroImageComponent = ({ image = { filename: null }, position = null }) => {
  const { filename, alt, title, copyright, source: imageSource } = image;

  const hasSourceOrCopyright = !!copyright || !!imageSource;

  const { sources, blurSources, src, blurSrc } = useStoryblokImage(filename);
  const { isMobile, isTablet, isDesktop, isLargeDesktop, isExtraLargeDesktop } = useScreenSize();
  const height = isExtraLargeDesktop
    ? 500
    : isLargeDesktop
    ? 460
    : isDesktop
    ? 360
    : isTablet
    ? 320
    : isMobile
    ? 240
    : 460;

  const anchorRef = useRef(null);

  if (!filename) return null;

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box
        ref={anchorRef}
        sx={{
          height: `${height}px`,
          position: 'relative',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <ProgressiveImage
          addHelmet
          alt={alt}
          blurSources={blurSources}
          blurSrc={blurSrc}
          height={`${height}px`}
          imageStyle={{
            objectPosition: position || 'center center',
          }}
          loadLazy={false}
          sources={sources}
          src={src}
          title={title}
        />
      </Box>
      {hasSourceOrCopyright ? (
        <Typography component="div" sx={{ ml: 1, mt: 1 }} variant="caption">
          {copyright}
          {imageSource ? ` | ` : null}
          {imageSource ? (
            <a href={imageSource} rel="nofollow noreferrer" target="_blank">
              Link
            </a>
          ) : null}
        </Typography>
      ) : null}
    </Container>
  );
};

StoryblokBlogPostHeroImageComponent.displayName = 'StoryblokBlogPostHeroImage';
const StoryblokBlogPostHeroImage = memo(StoryblokBlogPostHeroImageComponent);

export default StoryblokBlogPostHeroImage;
